import { eBaoCaoActionsObj } from "../../action-types/bao-cao/IBaoCaoActionTypes";
import { generateActions } from "../generateActions";

export const baoCaoActions = {
  ...generateActions(eBaoCaoActionsObj, "BAO_CAO"),
  
};
